import { useState, useEffect } from "react";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
//primeReact
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "primereact/datatable";
import { BreadCrumb } from "primereact/breadcrumb";
//components]
import Panel from "../../../components/panel/panel";
import ModalEditCurrentAccount from "./ModalEditAccount";
import ExportTable from "../../../components/button/ExportButton";
import ModalCreateCurrentAccount from "./ModalCreateCurrentAccount";
//services
import { getOwner } from "../../../services/GlobalRoles/getOwner";
import { getAccount } from "../../../services/GlobalRoles/getAccount";
import usePermission from "../../../hooks/usePermission";
import { useAppContext } from "../../../context/AppContext";
import { confirmDialog } from "primereact/confirmdialog";
import { deleteCurrentAccount } from "../../../services/CurrentAccount/deleteCurrentAccount";
import { toast } from "react-toastify";

const CurrentAccount = () => {
  usePermission("145"); // Visualizar Conta Corrente

  const { permissions } = useAppContext();
  const items = [
    {
      template: () => (
        <Link to={`/settings/currentAccount`} className="p-breadcrumb-link">
          Conta Corrente
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const [visible, setVisible] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [headerModal] = useState("Cadastrar");
  const [headerEditModal] = useState("Alterar");
  const [loading, setLoading] = useState(false); // Inicialmente, vazio
  const [sendRowData, setSendRowData] = useState([]);
  const [visibleEditModal, setVisibleEditModal] = useState(false);
  const [tableToExport, setTableToExport] = useState(null);

  const columns = [
    { field: "name_bank", header: "Banco" },
    { field: "agencyAndDigit", header: "Agencia / Dig" },
    { field: "accountNumberAndDigit", header: "Nº Conta / Dig" },
    { field: "nameCompany", header: "Empresa" },
  ];

  const exportColumns = columns.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const onGlobalFilterChange = (e) => {
    setGlobalFilterValue(e.target.value);
  };

  const handleCloseModal = () => {
    setVisible(false);
  };
  const handleCloseEditModal = () => {
    setVisibleEditModal(false);
  };

  function SubmitEditAccount(rowData) {
    setSendRowData(rowData);
    setVisibleEditModal(true);
  }
  const handleDelete = (data) => {
    console.log(data);

    var descrAccount = `${data.name_bank} | Agência: ${data.agency} - ${data.agency_digit} | Conta: ${data.account_number} - ${data.account_digit}`;
    confirmDialog({
      message: `Deseja excluir a conta corrente: ${descrAccount}?`,
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => handleDeleteAccount(data.id),
    });
  };

  const handleDeleteAccount = async (data) => {
    console.log(data);
    const notification = toast.loading("Por favor aguarde...");
    try {
      await deleteCurrentAccount(data);
      await refetch();

      toast.update(notification, {
        render: "Conta Corrente Deletada com Sucesso",
        autoClose: 2000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      console.log(error);
      const errorMessage =
        error.message || "Houve um erro ao excluir conta corrente!";
      refetch();

      toast.update(notification, {
        render: errorMessage,
        autoClose: 3000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
    }
  };

  //get
  const { data: account, refetch } = useQuery("account", () => getAccount(), {
    enabled: !!permissions?.includes("145"),
  });

  const { data: owners, isLoading: isLoadingOwners } = useQuery(
    ["owners"],
    () => getOwner(),
    { enabled: !!permissions?.includes("59") }
  );

  useEffect(() => {
    if (account) {
      // console.log(account);
      const dataWithoutIds = account.map((t) => ({
        NomeBanco: t.name_bank,
        Agencia: t.agency_digit,
        NumeroConta: t.accountNumberAndDigit,
        Empresa: t.nameCompany,
      }));
      // console.log("sem ids", dataWithoutIds);
      setTableToExport(dataWithoutIds);
    }
  }, [account]);

  return (
    <>
      <div className="d-flex justify-content-between">
        <div className="col-xl-4 col-md-6">
          <BreadCrumb model={items} home={home} className="breadCrumb" />
        </div>
        {permissions &&
          permissions.includes("146") && ( // Adicionar Conta Corrente
            <div className="col-xl-2 col-md-6">
              <Button
                loading={loading}
                rounded
                label="Nova Conta"
                icon="fa fa-plus"
                onClick={() => setVisible(true)}
                className="p-inputtext-sm me-2 m-auto w-100"
              />
            </div>
          )}
      </div>
      <Panel mainCss="mt-4" title="Conta Corrente">
        {!account ? (
          <Skeleton variant="rect" width="100%" height={300} />
        ) : (
          <>
            {/* <hr className="my-4" /> */}
            <div className="px-2 pb-3">
              <ExportTable
                tableData={tableToExport}
                tabelaKey="Contas"
                exportColumns={exportColumns}
                globalFilterValue={globalFilterValue}
                onGlobalFilterChange={onGlobalFilterChange}
              />
              <DataTable
                rows={10}
                paginator
                stripedRows
                showGridlines
                sortMode="multiple"
                selectionMode="single"
                rowsPerPageOptions={[10, 25, 100]}
                value={account}
                totalRecords={account}
                globalFilter={globalFilterValue}
                emptyMessage="Nenhuma Informação foi encontrada."
                tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
              >
                {columns.map((col) => (
                  <Column
                    sortable
                    key={col.field}
                    field={col.field}
                    header={col.header}
                  />
                ))}
                {permissions &&
                  permissions.includes("147") && ( // Editar Conta Corrente
                    <Column
                      header="Ver/Alterar"
                      body={(rowData) => (
                        <div className="text-center">
                          <button
                            disabled={loading}
                            loading={loading}
                            className="btn btn-success btn-btn-sm"
                            onClick={() => SubmitEditAccount(rowData)}
                          >
                            <i className="fa-solid fa-pen-to-square"></i>
                          </button>
                        </div>
                      )}
                    />
                  )}
                {permissions &&
                  permissions.includes("148") && ( //Deletar Conta Corrente
                    <Column
                      header="Excluir"
                      body={(rowData) => (
                        <div className="text-center">
                          <button
                            className="btn btn-danger btn-btn-sm"
                            onClick={() => handleDelete(rowData)}
                          >
                            <i className="fa-solid fa-trash"></i>
                          </button>
                        </div>
                      )}
                    />
                  )}
              </DataTable>
            </div>
          </>
        )}
      </Panel>

      <ModalEditCurrentAccount
        visible={visibleEditModal}
        headerModal={headerEditModal}
        handleCloseModal={handleCloseEditModal}
        setVisible={setVisibleEditModal}
        rowData={sendRowData}
        owners={owners}
        refresh={refetch}
        loadingAccount={setLoading}
        isLoadingOwners={isLoadingOwners}
      />

      <ModalCreateCurrentAccount
        visible={visible}
        headerModal={headerModal}
        handleCloseModal={handleCloseModal}
        setVisible={setVisible}
        owners={owners}
        refresh={refetch}
        loadingAccount={setLoading}
        currentAccount={account}
      />
    </>
  );
};

export default CurrentAccount;
